<template>
  <ba-modal name="modal-manual-calculation" height="auto" @closed="modalClosed">
    <ba-modal-content :title="`${$t('manualCalculation.title')}`">
      <p v-html="$t('manualCalculation.content')"></p>
      <template v-slot:cta-footer>
        <ba-button mod-naked @click="$modal.hide('modal-manual-calculation')">{{ $t('generic.cancel') }}</ba-button>
      </template>
    </ba-modal-content>
  </ba-modal>
</template>

<script>
import { BaModalContent } from '@/components/molecules/ba-modal-content/vue';
import { BaButton } from '@/components/atoms/ba-button/vue/';

export default {
  components: {
    BaModalContent,
    BaButton,
  },
  methods: {
    modalClosed() {
      this.$store.dispatch('general/setManualCalculation', false);
    },
  },
};
</script>
